import {
  EventHandlerPayloadResolveMoment,
  IDynamicSimpleText,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { createLink } from './link';
import { recommendationUrlRedirect } from '@epicuro-next/state/recommendation-panels-state';
import { eventHandlerFromAction } from '../../utils/eventhandler-from-action';

const linkContent: IDynamicSimpleText = {
  id: 'see-more-link-content',
  contentTypeId: 'dynamic-elements-simple-text',
  inputs: {
    text: {
      provider: 'id:root',
      property: 'seeMoreLinkText',
    },
  },
};

const routeProvider = {
  provider: 'id:root',
  property: 'seeMoreLinkResolved',
};

const seeMoreLink = createLink('see-more-link', routeProvider, linkContent);

seeMoreLink.inputs.routerLink =
  null as unknown as typeof seeMoreLink.inputs.routerLink;
seeMoreLink.styles.classes = [...seeMoreLink.styles.classes, 'cursor-pointer'];

seeMoreLink.eventHandlers = {
  onClick: [
    eventHandlerFromAction(recommendationUrlRedirect, {
      id: 'recommendation-search-see-more-click',
      payloadFetchMoment: EventHandlerPayloadResolveMoment.AtEvent,
      payload$: {
        values: [
          {
            provider: 'id:root',
            property: 'panelName',
          },
          {
            provider: 'id:root',
            property: 'seeMoreLinkResolved',
          },
          {
            provider: 'id:root',
            property: 'panelTrackingId',
          },
        ],
        transform: function ([panelName, routerLink, panelStyle]: [
          string,
          string,
          string,
        ]) {
          return {
            panelName,
            routerLink,
            panelStyle,
            seeMore: true,
          };
        }.toString(),
      },
    }),
  ],
};

seeMoreLink.if = [
  'EQ',
  [
    {
      provider: 'id:root',
      property: 'displaySeeMoreLink',
      transform: function (
        displaySeeMoreLink?: boolean | string | null,
      ): boolean {
        if (displaySeeMoreLink === undefined || displaySeeMoreLink === null) {
          return false;
        }

        if (typeof displaySeeMoreLink === 'string') {
          displaySeeMoreLink =
            displaySeeMoreLink.trim().toLowerCase() === 'true';
        }

        return displaySeeMoreLink;
      }.toString(),
    },
    true,
  ],
];

export const SeeMoreSearchByUrl = seeMoreLink;
